"use client";
import { BrowserTab } from "@/components/browser-tab";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { Button } from "@workspace/ui/components";
import { Pause, Play, Volume2, VolumeX } from "lucide-react";
import { useInView } from "motion/react";

export const Trailer = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isInView = useInView(videoRef, { margin: "-100px 0px -100px 0px" });
  const [muted, setMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  const toggleAudio = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
    }
  };

  const stop = () => {
    videoRef.current?.pause();
  };
  const play = () => {
    videoRef.current?.play();
  };

  useEffect(() => {
    videoRef.current?.addEventListener("play", () => setIsPlaying(true));
    videoRef.current?.addEventListener("pause", () => setIsPlaying(false));
    videoRef.current?.addEventListener("volumechange", () =>
      setMuted(!!videoRef.current?.muted),
    );
    videoRef.current?.play();
  }, []);

  useEffect(() => {
    if (isInView) {
      videoRef.current?.play();
    } else {
      videoRef.current?.pause();
    }
  }, [isInView]);
  return (
    <div
      className="relative flex justify-center w-full overflow-x-hidden px-5"
      id="demo"
    >
      <div className="absolute z-[-1] w-[200%] 2xl:w-full top-1/2 left-1/2 -translate-1/2 flex items-center">
        {/* <Lottie */}
        {/*   animationData={dotsFull} */}
        {/*   className="w-full h-full object-cover" */}
        {/*   style={{ width: "full", height: "full", objectFit: "cover" }} */}
        {/* /> */}
        <Image
          src="/landing/dots.png"
          width={1504}
          height={328}
          alt="dots"
          className="object-cover w-1/2 h-full"
        />
        <Image
          src="/landing/dots.png"
          width={1504}
          height={328}
          alt="dots"
          className="object-cover w-1/2 h-full"
        />
      </div>
      <BrowserTab>
        <div className="relative w-full h-full">
          {isPlaying && (
            <div className="absolute bottom-0 left-0 w-full h-fit z-20 p-5 gap-5 flex items-center">
              <Button
                onClick={stop}
                variant="d-primary"
                className="border-none size-[50px]"
              >
                <Pause size={24} fill="black" />
              </Button>
              <Button
                onClick={toggleAudio}
                variant="d-primary"
                className="border-none size-[50px]"
              >
                {muted ? (
                  <VolumeX size={24} fill="black" />
                ) : (
                  <Volume2 size={24} fill="black" />
                )}
              </Button>
            </div>
          )}
          <video
            ref={videoRef}
            src="/trailer.webm"
            className="w-full h-full absolute top-0 left-0 object-cover"
            controls={false}
            loop
            muted
            autoPlay
            playsInline
          />

          {!isPlaying && (
            <>
              <Image
                src="/preview.jpg"
                alt="preview"
                width={1100}
                height={780}
                className="object-cover absolute top-0 left-0 w-full h-full"
              />
              <div className="absolute flex items-center justify-center w-full h-full bg-[rgba(37,25,3,.56)] top-0 left-0">
                <Button
                  onClick={play}
                  variant="d-primary"
                  className="border-none size-[50px]"
                >
                  <Play size={24} fill="black" />
                </Button>
              </div>
            </>
          )}
        </div>
      </BrowserTab>
    </div>
  );
};
